import createVueApp from '@/common/createApp'

Styxie.Initializers.MlapSettingsLsaAccounts = {
  index: async(props) => {
    const { default: SettingsLsaAccounts } = await import('@/vue_widgets/mlap/settings/lsa_accounts/index.vue')
    createVueApp(SettingsLsaAccounts, { props })
  }
}
